"use strict";
import React, {
  Component,
  forwardRef,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import axios from "axios";
import numeral from "numeral";
import { awsUrl2, awsUrl, awsUrl3 } from "../../config";
import Clamp from "react-multiline-clamp";
import { alpha } from "@mui/material/styles";
import MaterialTable, { MTableToolbar } from "material-table";
import { TableBody, TablePagination } from "@mui/material";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import Search from "@mui/icons-material/Search";
import Clear from "@mui/icons-material/Clear";
import FirstPage from "@mui/icons-material/FirstPage";
import LastPage from "@mui/icons-material/LastPage";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Check from "@mui/icons-material/Check";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AddBox from "@mui/icons-material/AddBox";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Edit from "@mui/icons-material/Edit";
import FilterList from "@mui/icons-material/FilterList";
import Remove from "@mui/icons-material/Remove";
import ViewColumn from "@mui/icons-material/ViewColumn";
import SaveAlt from "@mui/icons-material/SaveAlt";
import parse from "html-react-parser";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { setCommentBoxColor } from "../../utils/common";
import { RotatingLines } from "react-loader-spinner";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import CalendarToday from "@mui/icons-material/CalendarToday";

import carrierList from "../../utils/carrierList.json";
const { carrierMapping } = carrierList;

import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Popup from "../common/Popup";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { Auth } from "aws-amplify";
import { createCommentForDownload } from "../common/dashboard_helper";
import { useAuth } from "../../context/AuthProvider";
import { sanitizeInput } from "../../utils/sanitizeInput";

const moment = require("moment");

const {
  DownloadDashboardFiles,
} = require("../subcompo/DownloadDashboardFiles.jsx");

let ismobile = window.innerWidth < 1600;

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: () => <div />,
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

// Fein format and adding 0 precedence
const formatFein = (value) => {
  if (!value) return "-";
  let fein = "-";
  value = value.split("-").join("");
  var len = value.length,
    dummystr = "000000000";

  if (len === 0) {
    fein = "-";
  } else if (len > 0 && len < 9) {
    value = dummystr.slice(0, 9 - len) + "" + value;
    fein = value[0] + value[1] + "-" + value.slice(2);
  } else {
    fein = value[0] + value[1] + "-" + value.slice(2);
  }

  return fein;
};
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
// Camel case for companyName
const camelCase = (str) => {
  if (str)
    return str
      .trim()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  return str;
};

const fontfunciton = () => {
  if (window.innerWidth < 1600 && window.innerWidth > 1500) {
    return "0.84rem";
  }
  if (window.innerWidth < 1500 && window.innerWidth > 1410) {
    return "0.8rem";
  }
  if (window.innerWidth < 1410 && window.innerWidth > 1310) {
    return "0.76rem";
  }
  if (window.innerWidth < 1300) {
    return "0.72rem";
  }
};
export const updateData = async (data) => {
  new Promise((resolve, reject) => {
    try {
      axios
        .post(awsUrl + "/api/underWriterData/update", data)
        .then((res) => {
          console.log("data saved");
          resolve();
        })
        .catch((err) => {
          console.log("error while saving", err);
          reject();
        });
    } catch (error) {}
  });
};

export const updateDataInUser = (data) => {
  new Promise((resolve, reject) => {
    try {
      let data_req = JSON.parse(JSON.stringify(data));
      if (data_req.sortKeyList) {
        delete data_req.sortKeyList;
      }
      axios
        .post(awsUrl2 + "/api/userTableData/update", data_req)
        .then((res) => {
          console.log("data saved");
          resolve();
        })
        .catch((err) => {
          console.log("error while saving", err);
          reject();
        });
    } catch (error) {}
  });
};

const toastSuccess = (text) =>
  toast.success(text, {
    duration: 3000,
  });

const toastError = (text) =>
  toast.error(text, {
    duration: 3000,
  });

let Changing_fontvalue = fontfunciton();
let initialcomment = {
  comment: "",
  commentTimestamp: "",
  email: "",
};

const SearchInputBar = React.memo(
  ({ inputRef, searchField, handleInputChange, onSearch }) => (
    <input
      ref={inputRef}
      type="text"
      style={{
        width: "272px",
        height: "38px",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        fontSize: "14px",
        outline: "none",
      }}
      title={`Company name, FEIN`}
      placeholder={`Company name, FEIN`}
      value={searchField}
      onChange={handleInputChange}
      onKeyDown={(e) => {
        if (e.key !== "Enter") return;
        onSearch();
      }}
    />
  ),
);

const ToolbarContext = React.createContext(null);

const CustomPagination = React.memo((props) => (
  <TablePagination
    {...props}
    labelRowsPerPage={<div style={{ fontSize: 12 }}>{""}</div>}
    labelDisplayedRows={(row) => <div style={{ fontSize: 12 }}>{""}</div>}
    slotProps={{
      select: {
        style: {
          fontSize: 12,
        },
      },
    }}
  />
));

const StableDatePicker = React.memo(
  ({ dateRange, handleDateChange }) => {
    const wrapperRef = useRef(null);

    return (
      <div
        ref={wrapperRef}
        className="d-flex align-items-center border"
        style={{ width: "auto", borderRadius: "4px" }}
      >
        <Flatpickr
          value={dateRange}
          onChange={handleDateChange}
          className="custom-flatpickr"
          placeholder="Created Date"
          style={{
            width: "225px",
            height: "38px",
            fontSize: "14px",
          }}
          options={{
            mode: "range",
            dateFormat: "m-d-Y",
            maxDate: moment().toDate(),
          }}
        />
        <CalendarToday
          style={{ color: "gray", cursor: "pointer" }}
          className="calendar-icon ms-2 px-1 "
          onClick={(e) => {
            e.stopPropagation();
            if (wrapperRef.current) {
              const input =
                wrapperRef.current.querySelector(".custom-flatpickr");
              if (input && input._flatpickr) {
                input._flatpickr.open();
              }
            }
          }}
        />
      </div>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.dateRange === nextProps.dateRange) return true;
    if (!prevProps.dateRange || !nextProps.dateRange) return false;
    if (
      Array.isArray(prevProps.dateRange) &&
      Array.isArray(nextProps.dateRange)
    ) {
      if (prevProps.dateRange.length !== nextProps.dateRange.length)
        return false;
      for (let i = 0; i < prevProps.dateRange.length; i++) {
        const d1 = prevProps.dateRange[i];
        const d2 = nextProps.dateRange[i];
        if (d1 instanceof Date && d2 instanceof Date) {
          if (d1.getTime() !== d2.getTime()) return false;
        } else if (d1 !== d2) {
          return false;
        }
      }
      return true;
    }
    return false;
  },
);

const CustomToolbar = React.memo((props) => {
  const context = React.useContext(ToolbarContext);
  if (!context || !context.tabsCheck["tab3"]) {
    return <MTableToolbar {...props} />;
  }

  const {
    dateRange,
    handleDateChange,
    searchField,
    handleInputChange,
    onSearch,
    inputRef,
  } = context;

  return (
    <div className="d-flex flex-row gap-3 justify-content-between w-100">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          paddingLeft: "10px",
          paddingRight: "20px",
        }}
      >
        <StableDatePicker
          dateRange={dateRange}
          handleDateChange={handleDateChange}
        />
        <SearchInputBar
          inputRef={inputRef}
          searchField={searchField}
          handleInputChange={handleInputChange}
          onSearch={onSearch}
        />
        <button
          className="btn btn-sm btnConfirmAll"
          color="primary"
          onClick={onSearch}
        >
          Search
        </button>
      </div>

      <div className="w-100">
        <MTableToolbar {...props} />
      </div>
    </div>
  );
});

const tableComponents = {
  Toolbar: CustomToolbar,
  Pagination: CustomPagination,
};

const UnderWriterTab = (props) => {
  const myRef = useRef();
  const inputRef = useRef();
  const [rowDataList, setRowDataList] = useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [searchField, setSearchField] = useState("");
  const [releasedRowDataList, setReleasedRowDataList] = useState([]);
  const [archiveRowDataList, setArchiveRowDataList] = useState([]);
  const [agentCommentsHistory, setAgentCommentsHistory] = useState({});
  const [submissionYesNoList, setSubmissionYesNoList] = useState({});
  const [isLoading, setIsLoading] = useState({
    tab1: true,
    tab2: true,
    tab3: false,
  });
  const [modalData, setModalData] = useState({});
  const [domainButtonMap, setDomainButtonMap] = useState({});
  const [style, setStyle] = useState({});
  const [tabsCheck, setTabsCheck] = useState({
    tab1: true,
    tab2: false,
    tab3: false,
  });
  const [scrollLeft, setScrollLeft] = useState(false);
  const [scrollRight, setScrollRight] = useState(true);
  const [loggedInUser, setLoggedInUser] = useState("");
  const [popupData, updatePopUpData] = useState({
    title: "",
    children: <></>,
    acceptBtn: "",
    acceptBtnCallback: () => {},
    rejectBtnCallback: () => {},
    show: false,
  });
  const [openModal, setOpenModal] = useState(false);
  const [modalBody, setModalBody] = useState([]);
  const [uwButton, setUwButton] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);

  const { user } = useAuth();

  useEffect(() => {
    getAllData();
    getUWReleasedData();
  }, []);

  const dateSort = (a, b, field) => {
    let momentA = moment(a[field], "M/D/YY");
    let momentB = moment(b[field], "M/D/YY");

    if (
      (!momentA.isValid() && momentB.isValid()) ||
      momentA.isBefore(momentB)
    ) {
      return -1;
    } else if (
      (momentA.isValid() && !momentB.isValid()) ||
      momentA.isAfter(momentB)
    ) {
      return 1;
    } else {
      return 0;
    }
  };

  const onReleaseClick = async (rowData) => {
    let dataToSave = {};
    dataToSave.user_email_id = rowData.user_email_id;
    dataToSave.sortKeyList = rowData.uuidCarriers;
    dataToSave.uw_status = "";
    let recordDetails = {
      uuidList: rowData.uuidCarriers,
      userId: rowData.user_email_id,
    };

    let isLoggedIn = user;
    let loggedIn_emailID = isLoggedIn.attributes.email;

    axios
      .post(awsUrl2 + "/api/removeSalesPersonFlag", recordDetails)
      .then(async (res) => {
        //filter to only show the required fields
        setRowDataList((prevstate) => {
          const _rowDataList = prevstate.filter(
            (element) => element["user_email_id"] !== rowData["user_email_id"],
          );
          return _rowDataList;
        });
        setReleasedRowDataList((prevstate) => {
          return [...prevstate, { ...rowData }];
        });
        let _updatedData = updateData(dataToSave);
        let _updateDataInUser = updateDataInUser(dataToSave);
        const combinedUserandUserStatusPromise = Promise.all([
          _updatedData,
          _updateDataInUser,
        ]);
        combinedUserandUserStatusPromise
          .then(([result1, result2]) => {
            console.log("updated both the table: " + result1, result2);
          })
          .catch((err) => {
            console.error(err);
          });

        await axios.post(awsUrl + "/api/updateStatusDetails", {
          button_name: "release_clicked",
          user_id: loggedIn_emailID,
          user_email_id: rowData.user_email_id,
          sort_key_list: rowData.uuidCarrier,
        });
      })
      .catch((err) => console.log("error: ", err));
  };

  const onClickCompanyName = async (rowData) => {
    const isSwitchUser = sessionStorage.getItem("isSwitchUser");
    const currentUser = sessionStorage.getItem("currentUser");

    sessionStorage.clear();

    if (isSwitchUser === "true") {
      sessionStorage.setItem("currentUser", currentUser);
      sessionStorage.setItem("isSwitchUser", "true");
    }

    await axios
      .post(awsUrl + "/api/underWriterData/fetchSortList", {
        user_email_id: rowData.user_email_id,
        dateuuid: `${rowData.quoteData.date}@${rowData.quoteData.uuid}`,
      })
      .then(async (res) => {
        if (rowData.currProspect) {
          let currProspect = { ...rowData.currProspect };
          if (rowData.targetPremium) {
            currProspect.targetPremium = rowData.targetPremium;
          }
          sessionStorage.setItem("currProspect", JSON.stringify(currProspect));
        }
        if (rowData.user_email_id) {
          sessionStorage.setItem("user_id", rowData.user_email_id);
        }
        sessionStorage.setItem("uw_flow", "true");

        if (rowData.salesforceData) {
          sessionStorage.setItem("salesforceData", rowData.salesforceData);
        }

        if (res.data.address) {
          sessionStorage.setItem("address", JSON.stringify(res.data.address));
        }

        if (rowData.quoteData) {
          sessionStorage.setItem(
            "quoteData",
            JSON.stringify(rowData.quoteData),
          );
        }

        if (res.data.uuid_carrier_list) {
          sessionStorage.setItem(
            "sortKeyList",
            JSON.stringify(res.data.uuid_carrier_list),
          );
        }

        if (rowData.amtrustAccountDetails) {
          sessionStorage.setItem(
            "amtrustAccountDetails",
            JSON.stringify(rowData.amtrustAccountDetails),
          );
        }
        if (rowData.amtrustAccountDetailsCopy) {
          sessionStorage.setItem(
            "amtrustAccountDetailsCopy",
            JSON.stringify(rowData.amtrustAccountDetailsCopy),
          );
        }
        if (rowData.amtrustNetRatesResponse) {
          sessionStorage.setItem(
            "amtrustNetRatesResponse",
            JSON.stringify(rowData.amtrustNetRatesResponse),
          );
        }
        if (rowData.amtrustEligibility) {
          sessionStorage.setItem(
            "AmtrustEligibility",
            JSON.stringify(rowData.amtrustEligibility),
          );
        }

        const response = await axios.post(
          awsUrl2 + "/api/userTableData/get",
          JSON.parse(
            JSON.stringify({
              user_email_id: rowData.user_email_id,
            }),
          ),
        );

        if (response.data.status === "") {
          sessionStorage.setItem("formStage", "one");
        } else {
          sessionStorage.setItem("formStage", "three");
        }

        window.location.href = "/Quote";
      })
      .catch((err) => console.log("error: ", err));
  };

  const selectedPeoFormat = (selectedPeo) => {
    let displayPEOName = selectedPeo?.toLowerCase();
    if (selectedPeo === "insurecomp") {
      displayPEOName = "LIB";
    } else if (selectedPeo === "esg halcyon") {
      displayPEOName = "ESG Halcyon";
    } else if (selectedPeo === "expresshr" || selectedPeo === "express hr") {
      displayPEOName = "Express HR";
    } else if (selectedPeo === "gregory") {
      displayPEOName = "J Gregory";
    } else if (selectedPeo === "totalsolution") {
      displayPEOName = "Total Solution";
    } else if (selectedPeo === "payrollmadeeasy") {
      displayPEOName = "Payroll Made Easy";
    }
    displayPEOName = displayPEOName?.replace(/\b\w/g, (char) =>
      char?.toUpperCase(),
    );

    // Capitalize entire word if it's only 4 or less than 4 letters
    if (displayPEOName?.length <= 4) {
      displayPEOName = displayPEOName?.toUpperCase();
    }
    return displayPEOName;
  };

  const columnData = [
    {
      title: "Submitted Date",
      field: "submittedDate",
      filterPlaceholder: "Filter",
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),
      customSort: (a, b) => dateSort(a, b, "submittedDate"),

      cellStyle: {
        wordBreak: "break-all",
        padding: "6px 0",
        minWidth: "80px",
        padding: "2px 0px 2px 16px",
      },
      headerStyle: {
        padding: "2px 0px 2px 16px",
        minWidth: "90px",
      },
    },
    {
      title: "Company Name",
      field: "companyname",
      filterPlaceholder: "Filter",

      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "200px",
        wordBreak: "break-word",
      },
      headerStyle: {
        padding: "6px 5px 6px 10px",
      },
      render: (rowData) => {
        return (
          <Clamp lines={2}>
            <span
              onClick={() => onClickCompanyName(rowData)}
              className="btn-link"
              style={{ cursor: "pointer" }}
            >
              {/* <Link to={"/Quote"}> */}
              {camelCase(rowData.companyname)}
              {/* </Link> */}
            </span>
          </Clamp>
        );
      },
      customSort: (a, b) => {
        const nameA = a.companyname.toUpperCase().trim();
        const nameB = b.companyname.toUpperCase().trim();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      },
    },
    {
      title: "FEIN",
      field: "fein",
      filterPlaceholder: "Filter",
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),

      cellStyle: {
        wordBreak: "break-all",
        padding: "2px 0px 2px 6px",
        minWidth: "90px",
      },
      headerStyle: {
        padding: "10px 0",
        minWidth: "90px",
      },
      render: (rowData) => formatFein(rowData.fein),
    },
    {
      title: "Primary State",
      field: "primaryState",
      filterPlaceholder: "Filter",

      cellStyle: {
        wordBreak: "break-all",
        padding: "2px 0px 2px 16px",
        minWidth: "90px",
      },
      headerStyle: {
        padding: "10px 0px 10px 16px",
        minWidth: "90px",
      },
      render: (rowData) => (
        <Clamp lines={1}>{rowData.primaryState || "-"}</Clamp>
      ),
    },
    {
      title: "Gov CC State",
      field: "govCcState",
      filterPlaceholder: "Filter",

      cellStyle: {
        wordBreak: "break-all",
        padding: "2px 0px 2px 6px",
        minWidth: "90px",
      },
      headerStyle: {
        padding: "10px 0",
        minWidth: "90px",
      },
      render: (rowData) => <Clamp lines={1}>{rowData.govCcState || "-"}</Clamp>,
    },
    {
      title: "Class code",
      field: "govClassCode",
      filterPlaceholder: "Filter",

      cellStyle: {
        wordBreak: "break-all",
        padding: "2px 0px 2px 6px",
        minWidth: "90px",
      },
      headerStyle: {
        padding: "10px 0",
        minWidth: "90px",
      },
      render: (rowData) => (
        <Clamp lines={1}>{rowData.govClassCode || "-"}</Clamp>
      ),
      customSort: (a, b) => {
        // Convert govClassCode to number for comparison
        const codeA = +a.govClassCode || 0;
        const codeB = +b.govClassCode || 0;
        return codeA - codeB;
      },
    },
    {
      title: "Payroll",
      field: "payroll",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        textAlign: "right",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "120px",
        paddingLeft: "1.5rem",
      },

      render: (rowData) => (
        <div className="payrollBox">
          <Clamp lines={1}>{rowData.payroll || "-"}</Clamp>
        </div>
      ),
    },
    {
      title: "Distributing Partners",
      field: "selectedPeoToDisplay",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "120px",
      },

      render: (rowData) => (
        <Clamp lines={1}>{rowData.selectedPeoToDisplay}</Clamp>
      ),
    },
    {
      title: "Submitted By",
      field: "submittedUserName",
      filterPlaceholder: "Filter",
      filtering: true,
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "00px",
        wordBreak: "break-word",
      },
      headerStyle: {
        padding: "6px 5px 6px 10px",
        minWidth: "00px",
      },
      render: (rowData) => {
        return <Clamp lines={1}>{rowData.submittedUserName || "-"}</Clamp>;
      },
      customSort: (a, b) => {
        const nameA = a.submittedUserName.toUpperCase();
        const nameB = b.submittedUserName.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      },
    },
    {
      title: "PEO",
      field: "peo",
      hidden: true,
      export: true,
      filtering: false,
      filterPlaceholder: "Filter",
      render: (rowData) => rowData.peo || "-",
      customSort: (a, b) => dateSort(a, b, "createdDate"),
      headerStyle: {
        display: "none",
        // padding: "0px 0px 0px 8px",
        // minWidth: "120px",
        // textAlign: "center",
      },
      cellStyle: {
        display: "none",
        // padding: "2px 0px 2px 6px",
        // minWidth: "120px",
        // width: "120px",
        // textAlign: "center",
      },
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),
    },
    {
      title: "Modified Date",
      field: "uploadTimestamp",
      filtering: true,
      filterPlaceholder: "Filter",
      render: (rowData) => rowData.uploadTimestamp,
      customSort: (a, b) => dateSort(a, b, "uploadTimestamp"),
      headerStyle: {
        padding: "0px 0px 0px 8px",
        minWidth: "120px",
        textAlign: "center",
      },
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "120px",
        textAlign: "center",
      },
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),
    },
    {
      title: "Comments",
      field: "uw_comments_download",
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "240px",
      },
      headerStyle: {
        minWidth: "240px",
      },
      render: (rowData) => {
        const callbackFunction = (data) => {
          updateData(data);
          updateDataInUser(data);
        };
        return (
          <div className="d-flex">
            <TextField
              key={`${rowData.user_email_id}_comment`}
              value={
                typeof rowData?.uw_comments?.[0] === "object"
                  ? rowData?.uw_comments?.[0]?.comment
                  : rowData?.uw_comments?.[0]
              }
              callback={callbackFunction}
              rowData={rowData}
              comments={rowData?.uw_comments}
              uw_comments="uw_comments"
              date={rowData?.submittedDate}
              user={user}
            />
            <Tooltip title="Click to view comment history" arrow>
              <button
                className="comment-btn"
                onClick={() =>
                  handleUWCommentHistoryButtonClick(
                    rowData,
                    rowData?.uw_comments,
                    rowData?.submittedDate,
                  )
                }
              >
                ...
              </button>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Agent Comments",
      field: "agent_comments_download",
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "210px",
      },
      headerStyle: {
        minWidth: "210px",
      },
      render: (rowData) => {
        const callbackFunction = (data) => {
          updateData(data);
          updateDataInUser(data);
        };
        return (
          <div className="d-flex">
            <TextField
              key={`${rowData.user_email_id}_comment`}
              value={
                typeof rowData?.agent_comments?.[0] === "object"
                  ? rowData?.agent_comments?.[0]?.comment ||
                    rowData?.agent_comments?.[0].comment
                  : rowData?.agent_comments?.[0]
              }
              callback={callbackFunction}
              rowData={rowData}
              comments={rowData?.agent_comments}
              agent_comments="agent_comments"
              user={user}
            />
            <Tooltip title="Click to view comment history" arrow>
              <button
                className="comment-btn"
                onClick={() =>
                  handleAgentCommentHistory(
                    [rowData],
                    `${rowData.user_email_id}`,
                  )
                }
              >
                ...
              </button>
            </Tooltip>
          </div>
        );
      },
    },
    {
      // title: (
      //   <img
      //     src={require("../../images/file-download-circle-green.svg")}
      //     alt=""
      //     style={{
      //       width: "40px",
      //       // filter: "grayscale(100%)  opacity(0.4)",
      //     }}
      //   />),
      title: "Download",
      filtering: false,
      sorting: false,
      disableSortBy: true,
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "55px",
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "right",
        padding: "6px 2px 4px 14px",
      },
      render: (rowData) => {
        let title = "";

        if (rowData?.fileListToStore?.length) {
          for (let file of rowData?.fileListToStore) {
            let fileToDisplay = file.split("/");
            title =
              title + fileToDisplay[fileToDisplay.length - 1] + " &#013; ";
          }
        }

        return (
          <button
            className="btn pt-0"
            type="button"
            title={parse(title)}
            data-html="true"
            onClick={() => {
              setModalData({
                showModel: true,
                modalTitle: <h1>{"Download"}</h1>,
                modalContent: (
                  <>
                    <DownloadDashboardFiles
                      fileListToStore={rowData.fileListToStore}
                    />
                  </>
                ),
              });
            }}
          >
            <img
              src={
                require("../../images/file-download-circle-green.svg").default
              }
              alt=""
              style={
                rowData?.fileListToStore?.length
                  ? {
                      width: "30px",
                      filter: "grayscale(0)",
                    }
                  : {
                      width: "30px",
                      filter: "grayscale(100%)  opacity(0.4)",
                    }
              }
            />
          </button>
        );
      },
    },
    {
      title: "Status",
      field: "uw_status",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "80px",
      },
      render: (rowData) => {
        return (
          <>
            <select
              id="statusDrop"
              value={domainButtonMap[rowData?.user_email_id]?.uw_status}
              onChange={(event) => {
                let statusMapping = {
                  Bound: "Bound",
                  Quoted: "Quoted",
                  Closed: "Closed",
                  Declined: "Declined",
                  "UW Quest": "UW Quest",
                  Submitted: "Submitted",
                };
                if (event.target.value === statusMapping[event.target.value]) {
                  updateButtonStatus(
                    rowData,
                    statusMapping[event.target.value],
                  );
                }
              }}
              style={{ height: "28px" }}
            >
              <option value={""}>Select</option>
              <option value="Bound"> Bound</option>
              <option value="Quoted"> Quoted</option>
              <option value="Closed"> Closed </option>
              <option value="Declined"> Declined</option>
              <option value="UW Quest"> UW Quest</option>
              <option value="Submitted"> Submitted </option>
            </select>
          </>
        );
      },
    },
    {
      title: "Release",
      sorting: false,
      field: "Release",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "70px",
      },
      render: (rowData) => {
        return (
          <button
            className="btn btn-sm btn-warning"
            disabled={rowData?.dealConfirmed}
            onClick={(e) => {
              if (!rowData?.dealConfirmed)
                updatePopUpData({
                  show: true,
                  title: "",
                  children: (
                    <>
                      <br></br>
                      <span style={{ fontWeight: "bold" }}>
                        This action will release the prospect back to Agent. Do
                        you want to Proceed?
                      </span>
                    </>
                  ),
                  acceptBtn: "Yes",
                  acceptBtnCallback: async () => {
                    try {
                      await onReleaseClick(rowData);
                    } catch (error) {
                      console.log("error: ", error);
                    }
                  },
                });
            }}
          >
            Release
          </button>
        );
      },
    },
  ];

  const releasedColumnData = [
    {
      title: "Submitted Date",
      field: "submittedDate",
      filterPlaceholder: "Filter",
      // defaultSort: "asc",
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),

      cellStyle: {
        wordBreak: "break-all",
        padding: "6px 0",
        minWidth: "80px",
        padding: "2px 0px 2px 16px",
      },
      headerStyle: {
        padding: "2px 0px 2px 16px",
        minWidth: "90px",
      },
    },
    {
      title: "Company Name",
      field: "companyname",
      filterPlaceholder: "Filter",

      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "200px",
        wordBreak: "break-word",
      },
      headerStyle: {
        padding: "6px 5px 6px 10px",
      },
      render: (rowData) => {
        return <Clamp lines={2}>{camelCase(rowData.companyname)}</Clamp>;
      },
    },
    {
      title: "FEIN",
      field: "fein",
      filterPlaceholder: "Filter",
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),

      cellStyle: {
        wordBreak: "break-all",
        padding: "2px 0px 2px 6px",
        minWidth: "90px",
      },
      headerStyle: {
        padding: "10px 0",
        minWidth: "90px",
      },
      render: (rowData) => formatFein(rowData?.fein),
    },
    {
      title: "Payroll",
      field: "payroll",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        textAlign: "right",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "120px",
        paddingLeft: "2rem",
      },

      render: (rowData) => (
        <div className="releasedPayrollBox">
          <Clamp lines={1}>{rowData.payroll || "-"}</Clamp>
        </div>
      ),
    },
    {
      title: "Comments",
      field: "uw_comments",
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "140px",
      },
      render: (rowData) => {
        const callbackFunction = (data) => {
          updateData(data);
          updateDataInUser(data);
        };
        return (
          <TextField
            key={`${rowData.user_email_id}_comment`}
            value={
              typeof rowData?.uw_comments?.[0] === "object"
                ? rowData?.uw_comments?.[0]?.comment
                : rowData?.uw_comments?.[0]
            }
            callback={callbackFunction}
            rowData={rowData}
            uw_comments="uw_comments"
            uw_disabled="uw_disabled"
            user={user}
          />
        );
      },
    },

    // {
    //   title: "Agent Comments",
    //   field: "agent_comments",
    //   filterPlaceholder: "Filter",
    //   cellStyle: {
    //     padding: "2px 0px 2px 6px",
    //     minWidth: "140px",
    //   },
    //   render: (rowData) => {
    //     const callbackFunction = (data) => {
    //       updateData(data);
    //       updateDataInUser(data);
    //     };
    //     return (
    //       <TextField
    //         key={`${rowData.user_email_id}_comment`}
    //         value={rowData?.agent_comments}
    //         callback={callbackFunction}
    //         rowData={rowData}
    //         agent_comments="agent_comments"
    //       />
    //     );
    //   },
    // },
  ];

  const archiveColumnData = [
    {
      title: "Created Date",
      field: "createdDate",
      filtering: true,
      filterPlaceholder: "Filter",
      render: (rowData) => rowData.createdDate,
      customSort: (a, b) => dateSort(a, b, "createdDate"),
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "200px",
        maxWidth: "410px",
      },
      cellStyle: {
        padding: "2px 0px 2px 12px",
        minWidth: "200px",
        maxWidth: "410px",
      },
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),
    },
    {
      title: "Company Name",
      field: "companyName",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 12px",
        minWidth: "200px",
        maxWidth: "410px",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "200px",
        maxWidth: "410px",
      },
      filterCellStyle: {
        padding: "5px 0px 5px 4px",
      },
      render: (rowData) => (
        <Clamp lines={2}>
          <span>
            <div>{camelCase(rowData?.companyName)}</div>
          </span>
        </Clamp>
      ),
      customSort: (a, b) => {
        const nameA = a.companyName.toUpperCase().trim();
        const nameB = b.companyName.toUpperCase().trim();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      },
    },
    {
      title: "FEIN",
      field: "fein",
      filterPlaceholder: "Filter",
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),

      cellStyle: {
        wordBreak: "break-all",
        padding: "2px 0px 2px 2px",
        minWidth: "100px",
      },
      headerStyle: {
        padding: "10px 0",
        minWidth: "100px",
      },
      render: (rowData) => (
        <Clamp lines={1}>{formatFein(rowData?.fein) || ""}</Clamp>
      ),
    },
    {
      title: "Gov CC State",
      field: "govCCState",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "90px",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "60px",
        width: "60px",
      },

      render: (rowData) => <Clamp lines={1}>{rowData.govCCState || "-"}</Clamp>,
    },
    {
      title: "Primary State",
      field: "state",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "60px",
        textAlign: "center",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "60px",
        width: "60px",
        textAlign: "center",
      },

      render: (rowData) => <Clamp lines={1}>{rowData.state || "-"}</Clamp>,
    },
    {
      title: "Class Code",
      field: "govClassCode",
      // customFilterAndSearch: (term, rowData, field) =>
      //   this.customFilterfunction(term, rowData, field),

      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "40px",
        textAlign: "center",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "40px",
        width: "40px",
        textAlign: "center",
      },

      render: (rowData) => (
        <Clamp lines={1}>{rowData.govClassCode || "-"}</Clamp>
      ),
      customSort: (a, b) => {
        // Convert govClassCode to number for comparison
        const codeA = +a.govClassCode || 0;
        const codeB = +b.govClassCode || 0;
        return codeA - codeB;
      },
    },
    {
      title: "Effective Date",
      field: "effectiveDate",
      filtering: true,
      filterPlaceholder: "Filter",
      render: (rowData) => rowData.effectiveDate,
      customSort: (a, b) => dateSort(a, b, "effectiveDate"),
      headerStyle: {
        padding: "0px 0px 0px 8px",
        minWidth: "120px",
        textAlign: "center",
      },
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "120px",
        textAlign: "center",
      },
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),
    },
    {
      title: "Distributing Partners",
      field: "selectedPeoToDisplay",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "180px",
        textAlign: "left",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "180px",
        textAlign: "left",
      },
      render: (rowData) => (
        <Clamp lines={1}>{rowData.selectedPeoToDisplay || "-"}</Clamp>
      ),
    },
    {
      title: "Location",
      field: "agency",
      filtering: true,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "180px",
        textAlign: "left",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "180px",
        textAlign: "left",
      },
      render: (rowData) => <Clamp lines={1}>{rowData.agency || "-"}</Clamp>,
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      filtering: true,
      filterPlaceholder: "Filter",
      render: (rowData) => (
        <Clamp lines={1}>
          {rowData.modifiedBy
            ? rowData.modifiedBy.split("@")[0].length <= 3
              ? rowData.modifiedBy.split("@")[0].toUpperCase()
              : rowData.modifiedBy.split("@")[0][0].toUpperCase() +
                rowData.modifiedBy.split("@")[0].slice(1)
            : ""}
        </Clamp>
      ),

      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "120px",
      },
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "120px",
      },
    },
    {
      title: "Status",
      field: "step",
      filtering: true,
      filterPlaceholder: "Filter",
      // cellStyle: (e, rowData) => {
      //   let style = { padding: "6px 15px 6px 10px", minWidth: "110px" };
      //   let stepValue = rowData?.uwStatus || rowData?.step;
      //   if (stepValue === "Quote Generated") {
      //     style.backgroundColor = "#87FA4D";
      //   } else if (stepValue === "rejected") {
      //     style.backgroundColor = "#cb2e3e";
      //   } else if (stepValue === "onHold") {
      //     style.backgroundColor = "#ffbd16";
      //   } else if (stepValue === "Underwriting Page") {
      //     style.backgroundColor = "#fa6d3e";
      //   } else {
      //     style.backgroundColor = "#FFF";
      //   }
      //   return style;
      // },
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "125px",
      },
      headerStyle: {
        padding: " 0px 15px 0px 10px",
        minWidth: "110px",
      },
      render: (rowData) => (
        <Clamp lines={1}>
          {rowData.uwStatus ||
            (rowData.quoteSubmitted ? "Submitted" : "") ||
            rowData.step}
        </Clamp>
      ),
      customSort: (a, b) => {
        // Define the priority of each status
        const statusOrder = {
          approved: 1,
          Bound: 2,
          Closed: 3,
          Declined: 4,
          onHold: 5,
          "Quote Generated": 6,
          Quoted: 7,
          rejected: 8,
          Submitted: 9,
          "Underwriting Page": 10,
          "UW Quest": 11,
        };
        // Get the status values
        const statusA =
          a.uwStatus || (a.quoteSubmitted ? "Submitted" : "") || a.step;
        const statusB =
          b.uwStatus || (b.quoteSubmitted ? "Submitted" : "") || b.step;
        // Get the order values, default to a large number for undefined statuses
        const orderA = statusOrder[statusA] || 100;
        const orderB = statusOrder[statusB] || 100;
        // Compare the order values
        return orderA - orderB;
      },
    },
    {
      title: "Unarchive",
      field: "unarchive",
      filtering: false,
      filterPlaceholder: "Filter",
      cellStyle: {
        padding: "2px 0px 2px 12px",
        minWidth: "200px",
        maxWidth: "410px",
      },
      headerStyle: {
        padding: " 0px 0px 0px 10px",
        minWidth: "200px",
        maxWidth: "410px",
      },
      filterCellStyle: {
        padding: "5px 0px 5px 4px",
      },
      render: (rowData) => (
        <Clamp lines={2}>
          <span>
            <button
              className="btn btn-sm btnConfirmAll"
              onClick={() => handleUnarchive(rowData)}
            >
              Unarchive
            </button>
          </span>
        </Clamp>
      ),
      customSort: (a, b) => {
        const nameA = a.companyName.toUpperCase().trim();
        const nameB = b.companyName.toUpperCase().trim();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      },
    },
    {
      title: "UW Comment",
      field: "uw_comments_download",
      filtering: true,
      filterPlaceholder: "Filter",
      render: (rowData) => {
        return (
          <div className="d-flex">
            <textarea
              value={
                typeof rowData?.uw_comments?.[0] === "object"
                  ? rowData?.uw_comments?.[0]?.comment
                  : rowData?.uw_comments?.[0] || rowData?.uw_comments || ""
              }
              className="underwriter_comment"
              rows="1"
              disabled
              style={{
                width: "100%",
                backgroundColor: setCommentBoxColor(rowData?.uw_comments),
              }}
            ></textarea>
            <Tooltip title="Click to view comment history" arrow>
              <button
                className="comment-btn"
                onClick={
                  () =>
                    handleUwCommentHistory(
                      [rowData],
                      `${rowData?.user_email_id}`,
                    )
                  // console.log([rowData], `${rowData.user_email_id}`)
                }
              >
                ...
              </button>
            </Tooltip>
          </div>
        );
      },
      headerStyle: {
        padding: " 0px 0px 0px 21px",
        minWidth: "240px",
      },
      filterCellStyle: {
        padding: "5px 5px 5px 14px",
      },
      cellStyle: {
        padding: "2px 9px 2px 6px",
        minWidth: "240px",
        width: "240px",
      },
    },
    {
      title: "Comments",
      field: "agent_comments_download",
      filtering: true,
      filterPlaceholder: "Filter",
      headerStyle: {
        padding: "0px 10px 0px 21px",
        minWidth: "240px",
      },
      filterCellStyle: {
        padding: "5px 5px 5px 14px",
      },
      cellStyle: {
        padding: "2px 10px 2px 6px",
        minWidth: "240px",
        width: "240px",
      },
      render: (rowData) => {
        const callbackFunction = (data) => {
          console.log("inside callback", data);
          console.log(rowData);
          updateData(data);
          updateDataInUser(data);
        };
        return (
          <div className="d-flex">
            <TextField
              key={`${rowData?.user_email_id}_comment`}
              value={
                typeof agentCommentsHistory[rowData?.user_email_id]?.[0] ===
                "object"
                  ? agentCommentsHistory[rowData?.user_email_id]?.[0]?.comment
                  : agentCommentsHistory[rowData?.user_email_id]?.[0]
              }
              callback={callbackFunction}
              rowData={rowData}
              agentCommentsHistory={
                agentCommentsHistory[rowData?.user_email_id]
              }
              handleAgentCommentHistory={handleAgentCommentHistory}
              comments={agentCommentsHistory[rowData?.user_email_id]}
              user={user}
            />
            <Tooltip title="Click to view comment history" arrow>
              <button
                className="comment-btn"
                onClick={
                  () =>
                    handleAgentCommentsButtonClick(
                      agentCommentsHistory[rowData?.user_email_id],
                      rowData?.uploadTimestamp,
                    )
                  // console.log(
                  //   rowData,
                  //   rowData.agent_comments,
                  //   agentCommentsHistory[rowData.user_email_id]
                  // )
                }
              >
                ...
              </button>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Submitted Date",
      field: "submittedDate",
      filtering: true,
      filterPlaceholder: "Filter",
      render: (rowData) => rowData.submittedDate,
      customSort: (a, b) => dateSort(a, b, "submittedDate"),
      headerStyle: {
        padding: "0px 0px 0px 8px",
        minWidth: "120px",
        textAlign: "center",
      },
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "120px",
        textAlign: "center",
      },
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),
    },
    {
      title: "Modified Date",
      field: "uploadTimestamp",
      filtering: true,
      filterPlaceholder: "Filter",
      render: (rowData) => rowData.uploadTimestamp,
      customSort: (a, b) => dateSort(a, b, "uploadTimestamp"),
      headerStyle: {
        padding: "0px 0px 0px 8px",
        minWidth: "120px",
        textAlign: "center",
      },
      cellStyle: {
        padding: "2px 0px 2px 6px",
        minWidth: "120px",
        width: "120px",
        textAlign: "center",
      },
      customFilterAndSearch: (term, rowData, field) =>
        customFilterAll(term, rowData, field),
    },
  ];

  const customFilterAll = (term, rowData, field) => {
    let customFieldName = field["field"];

    return rowData[customFieldName]
      ?.toString()
      ?.toLowerCase()
      ?.startsWith(term?.toLowerCase());
  };
  const handleUWCommentHistoryButtonClick = (data, comments, submittedDate) => {
    setUwButton(true);
    if (comments !== undefined) {
      if (typeof comments[0] === "string" && comments[0] !== "") {
        let updatedComment = [
          {
            ...initialcomment,
            comment: comments[0],
            commentTimestamp: submittedDate,
          },
        ];
        setModalBody(updatedComment);
      } else {
        setModalBody(comments);
      }
    } else {
      setModalBody([initialcomment]);
    }
    setOpenModal(true);
  };

  const handleAgentCommentHistory = (rowdata, rowkey) => {
    setUwButton(false);
    rowdata.forEach((item) => {
      if (item.user_email_id === rowkey && item.agent_comments !== undefined) {
        if (typeof item.agent_comments[0] === "object") {
          setModalBody(item.agent_comments);
        } else if (typeof item.agent_comments[0] === "string") {
          let updatedComment = [
            {
              ...initialcomment,
              comment: item.agent_comments[0],
              commentTimestamp: item.submittedDate,
            },
          ];
          setModalBody(updatedComment);
        }
      } else if (item.agent_comments === undefined) {
        setModalBody([initialcomment]);
      }
    });
    setOpenModal(true);
  };

  const handleUnarchive = (rowData) => {
    updatePopUpData({
      show: true,
      title: "Do you wish to continue?",
      children: (
        <>
          <br></br>
          <span style={{ fontWeight: "bold" }}>
            {`Current record will be unarchived and moved to UW Dashboard.`}
          </span>
        </>
      ),
      acceptBtn: "Yes",
      acceptBtnCallback: () => {
        onUnarchive(rowData.user_email_id);
      },
    });
  };

  const onUnarchive = (user_email_id) => {
    axios
      .post(awsUrl3 + "/api/newBusiness/unarchive", {
        id: [user_email_id],
      })
      .then((res) => {
        setArchiveRowDataList((prevState) => {
          const updatedList = prevState.filter(
            (item) => item.user_email_id !== user_email_id,
          );
          return updatedList;
        });
      })
      .catch((error) => {
        console.log("error in onUnarchive", error);
      })
      .finally(() => {
        setIsLoading((prev) => ({ ...prev, tab3: false }));
      });
  };

  const onMultipleUnarchive = (selectedRows) => {
    setIsLoading((prev) => ({ ...prev, tab3: true }));

    axios
      .post(awsUrl3 + "/api/newBusiness/unarchive", {
        id: selectedRows.map((row) => row.user_email_id),
      })
      .then((res) => {
        setArchiveRowDataList((prevState) => {
          const updatedList = prevState.filter(
            (item) =>
              !selectedRows.some(
                (selected) => selected.user_email_id === item.user_email_id,
              ),
          );

          return updatedList;
        });
      })
      .catch((error) => {
        console.log("error in onMultipleUnarchive", error);
      })
      .finally(() => {
        setIsLoading((prev) => ({ ...prev, tab3: false }));
      });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleInputChange = (e) => {
    setSearchField(e.target.value);
    requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
  };

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 0) return setDateRange(null);
    if (selectedDates.length !== 2) return;

    setDateRange(selectedDates);
  };

  const searchIdRef = useRef(0);

  const onSearch = async () => {
    if (!searchField && (!dateRange || dateRange.length !== 2)) return;

    const searchId = ++searchIdRef.current;
    const filters = {
      searchField: sanitizeInput(searchField),
      dateRange,
    };

    setArchiveRowDataList([]);
    setIsLoading((prev) => ({ ...prev, tab3: true }));

    let lastEvaluatedKey = null;
    let accumulatedData = [];

    do {
      try {
        const res = await axios.post(awsUrl3 + "/api/newBusiness/getArchived", {
          ...filters,
          lastEvaluatedKey,
          quoteSubmittedOnly: true,
        });

        if (searchId !== searchIdRef.current) return;

        accumulatedData = [...accumulatedData, ...(res.data.data || [])];
        lastEvaluatedKey = res.data.lastEvaluatedKey;
      } catch (error) {
        console.log("error in onSearch", error);
        if (searchId === searchIdRef.current) {
          setIsLoading((prev) => ({ ...prev, tab3: false }));
          setArchiveRowDataList([]);
        }
        return;
      }
    } while (lastEvaluatedKey);

    if (searchId === searchIdRef.current) {
      const { rowDataList } = processRecords(accumulatedData);
      setArchiveRowDataList(rowDataList);
      setIsLoading((prev) => ({ ...prev, tab3: false }));
    }
  };

  const setTableData = (rowDataList, columnData, isLoading) => {
    // getting the data from backend

    const scrollLeftHandler = () => {
      const tableContainerDiv =
        myRef.current.lastChild.lastChild.children[2].children[1].children[0]
          .children[0];
      if (tableContainerDiv) {
        tableContainerDiv.scrollLeft -= 150;
        if (tableContainerDiv.scrollLeft == 0) {
          setScrollLeft(false);
          setScrollRight(true);
        }

        const maxScrollLeft =
          tableContainerDiv.scrollWidth - tableContainerDiv.clientWidth;

        if (tableContainerDiv.scrollLeft < maxScrollLeft) {
          setScrollRight(true);
        }
      }
    };
    const scrollRightHandler = () => {
      const tableContainerDiv =
        myRef.current.lastChild.lastChild.children[2].children[1].children[0]
          .children[0];

      if (tableContainerDiv) {
        tableContainerDiv.scrollLeft += 150;
        setScrollLeft(true);
      }

      const maxScrollLeft =
        tableContainerDiv.scrollWidth - tableContainerDiv.clientWidth;

      if (tableContainerDiv.scrollLeft >= maxScrollLeft) {
        setScrollRight(false);
      }
    };

    return (
      <>
        <div style={{ position: "relative" }}>
          {/* {scrollLeft && (
            <button className="ChevronLeft" onClick={scrollLeftHandler}>
              &lt;
            </button>
          )}
          {scrollRight && (
            <button className="ChevronRight" onClick={scrollRightHandler}>
              &gt;
            </button>
          )} */}
          <ToolbarContext.Provider
            value={{
              dateRange,
              handleDateChange,
              searchField,
              handleInputChange,
              onSearch,
              inputRef,
              tabsCheck,
            }}
          >
            <MaterialTable
              icons={tableIcons}
              data={rowDataList}
              columns={columnData}
              // actions={
              //   tabsCheck["tab3"]
              //     ? [
              //       {
              //         tooltip: "Unarchive",
              //         icon: () => (
              //           <button className="btn btn-sm btnConfirmAll">
              //             Unarchive
              //           </button>
              //         ),
              //         onClick: (event, data) => {
              //           updatePopUpData({
              //             show: true,
              //             title: "Do you wish to continue?",
              //             children: (
              //               <>
              //                 <br></br>
              //                 <span style={{ fontWeight: "bold" }}>
              //                   {`Selected records will be unarchived`}
              //                 </span>
              //               </>
              //             ),
              //             acceptBtn: "Yes",
              //             acceptBtnCallback: () => {
              //               onMultipleUnarchive(data);
              //             },
              //           });
              //         },
              //       },
              //     ]
              //     : undefined
              // }
              detailPanel={
                tabsCheck["tab1"] && false
                  ? [
                      {
                        tooltip: "Status info",
                        icon: () => <KeyboardArrowRightIcon />,
                        render: (rowData) => {
                          return (
                            <div style={{ padding: "25px" }}>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableHead
                                    style={{
                                      background: "#00000066",
                                      color: "whitesmoke",
                                    }}
                                  >
                                    <TableRow>
                                      <TableCell>Status</TableCell>
                                      <TableCell>Date</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {Object.values(
                                      rowData.status_info_rows,
                                    ).map((element, index) => {
                                      return (
                                        <TableRow key={index}>
                                          <TableCell scope="row">
                                            {element.status}
                                          </TableCell>
                                          <TableCell scope="row">
                                            {element.timestamp}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          );
                        },
                      },
                    ]
                  : undefined
              }
              options={{
                ...(tabsCheck["tab3"] && {
                  search: false,
                  selection: false,
                }),
                stickyHeader: true,
                // doubleHorizontalScroll: true,
                filtering: true,
                sorting: true,
                paginationPosition: "both",
                padding: "dense",
                showTitle: false,
                thirdSortClick: false,
                pageSize: 10,
                pageSizeOptions: [
                  10,
                  25,
                  50,
                  75,
                  100,
                  500,
                  1000,
                  rowDataList?.length ? rowDataList.length : 0,
                ],
                ...(!tabsCheck["tab3"] && {
                  exportFileName: "GetQuote Dashboard File",
                  exportButton: {
                    csv: true,
                    pdf: false,
                  },
                }),
                headerStyle: {
                  fontSize: ismobile ? fontfunciton() : "1rem",
                  backgroundColor: "#003764",
                  color: "#FFF",
                  padding: "6px 15px 6px 10px",
                  fontFamily: "Montserrat",
                },
                rowStyle: {
                  fontSize: ismobile ? fontfunciton() : "0.95rem",
                  color: "#000",
                  fontFamily: "Montserrat",
                },
                searchFieldStyle: {
                  fontSize: "0.95rem",
                },
              }}
              isLoading={isLoading}
              components={tableComponents}
            />
          </ToolbarContext.Provider>
        </div>
      </>
    );
  };

  // const ButtonGroup = (props) => {
  //   // const [isApproved, setIsApproved] = useState(false);
  //   // const [isRejected, setIsRejected] = useState(false);
  //   // const [isOnHold, setIsOnHold] = useState(false);

  //   // useEffect(() => {
  //   //   setIsApproved(
  //   //     props?.domainButtonMap?.[props?.rowData?.["user_email_id"] || "test"]
  //   //       ?.isApproved || false
  //   //   );
  //   //   setIsRejected(
  //   //     props?.domainButtonMap?.[props?.rowData?.["user_email_id"] || "test"]
  //   //       ?.isRejected || false
  //   //   );
  //   //   setIsOnHold(
  //   //     props?.domainButtonMap?.[props?.rowData?.["user_email_id"] || "test"]
  //   //       ?.isOnHold || false
  //   //   );
  //   // }, [
  //   //   props.domainButtonMap?.isApproved,
  //   //   props.domainButtonMap?.isRejected,
  //   //   props.domainButtonMap?.isOnHold,
  //   // ]);

  //   const updateButtonStatus = (status) => {
  //     let row = props.rowData;
  //     let _domainButtonMap = Object.assign({}, props.domainButtonMap);

  //     let dataToSave = {};
  //     dataToSave.user_email_id = row.user_email_id;
  //     dataToSave.sortKeyList = row.uuidCarriers;
  //     dataToSave.uw_status = status;

  //     if (status === "approved") {
  //       _domainButtonMap[row?.["user_email_id"]].isApproved = true;
  //     } else if (status === "rejected") {
  //       _domainButtonMap[row?.["user_email_id"]].isRejected = true;
  //     } else if (status === "onHold") {
  //       _domainButtonMap[row?.["user_email_id"]].isOnHold = true;
  //     }
  //     props.updateData(dataToSave);
  //     props.updateDataInUser(dataToSave);
  //     props.setDomainButtonMap(_domainButtonMap);
  //   };

  //   return (
  //     <div>
  //       <>
  //         <select
  //           // value={props?.rowData?.uw_status}
  //           defaultValue={props?.rowData?.uw_status}
  //           onChange={(event) => {
  //             console.log(event.target, props.rowData);
  //             if (event.target.value === "approved") {
  //               updateButtonStatus("approved");
  //             }
  //             if (event.target.value === "onHold") {
  //               updateButtonStatus("onHold");
  //             }
  //             if (event.target.value === "rejected") {
  //               updateButtonStatus("rejected");
  //             }
  //           }}
  //         >
  //           <option value="approved"> Approve</option>
  //           <option value="onHold"> onHold</option>
  //           <option value="rejected"> Rejected </option>
  //         </select>
  //       </>
  //     </div>
  //   );
  // };
  const updateButtonStatus = (rowData, status) => {
    let dataToSave = {};
    dataToSave.user_email_id = rowData.user_email_id;
    dataToSave.sortKeyList = rowData.uuidCarriers;
    dataToSave.uw_status = status;
    let _domainButtonMap = Object.assign({}, domainButtonMap);

    _domainButtonMap[rowData?.user_email_id].uw_status = status;

    // const modifiedRow = rowDataList.find(
    //   (row) => row?.user_email_id === rowData.user_email_id
    // );

    // try {
    //   modifiedRow.uw_status = status;
    // } catch (error) {
    //   // Handle the error
    //   console.log(error);
    // }

    updateData(dataToSave);
    updateDataInUser(dataToSave);
    // setRowDataList(rowDataList);
    setDomainButtonMap(_domainButtonMap);
  };

  const makeNameReadable = (str) => {
    let _str = "";
    if (str) {
      _str = str
        .split("_")
        .map((e) => {
          return e[0].toUpperCase() + e.substr(1);
        })
        .join(" ");
    }
    return _str;
  };

  const getAllDataApi = (_globalDbData, _lastEvaluatedKey) => {
    return new Promise(async (resolve, reject) => {
      let lastEvaluatedKey = _lastEvaluatedKey;
      let dataFromAPI = {};
      // do {
      try {
        await axios
          .post(awsUrl + "/api/underWriterData/getAll", { lastEvaluatedKey })
          .then((res) => {
            for (let domain in res.data.emailBasedData) {
              if (!dataFromAPI[domain] && !_globalDbData[domain]) {
                dataFromAPI[domain] = [...res.data.emailBasedData[domain]];
              }
              // dataFromAPI[domain].push(...res.data.emailBasedData[domain]);
            }
            // console.log("dataFromAPI", res.data.lastEvaluatedKey);

            lastEvaluatedKey = res.data.lastEvaluatedKey;
          });
      } catch (e) {
        console.log("API Error", e);
      }
      // } while (lastEvaluatedKey);
      resolve({ lastEvaluatedKey, dataFromAPI });
    });
  };

  const formatPayrollToNumber = (payroll) => {
    // Remove '$' and ',' and convert to number
    return payroll ? parseFloat(payroll.replace(/[^\d.-]/g, "")) : 0;
  };

  const processRecords = (userDataList) => {
    let rowData, step;
    let rowDataList = [];
    let emailToNameMap = {
      "akshay@mobiux.in": "Akshay",
    };

    let _submissionYesNoList = {},
      _agentCommentsHistory = {};

    for (let userDataRow in userDataList) {
      let userData = userDataList[userDataRow];
      let sortKeyPrepare = [];
      try {
        if (userData.status === "quote_generated") {
          step = "Quote Generated";
        } else if (userData.status === "company_profile") {
          step = "Underwriting Page";
        } else {
          step = "-";
        }

        // Calculating total Payroll

        let payroll = 0;
        let classcodeInfo;
        let sum = 0;

        let childloc = userData.childrenLoc;
        // console.log(userData)

        for (let userDataRow in childloc) {
          let userChildlocData = childloc[userDataRow];
          // console.log(userChildlocData);
          classcodeInfo = userChildlocData.classCodesInfo;
          classcodeInfo = Object.entries(classcodeInfo);
          // console.log(classcodeInfo)
          for (let i = 0; i < classcodeInfo.length; i++) {
            let paydata = classcodeInfo[i];
            const stringAmount = paydata[1]?.payroll?.value;
            if (!stringAmount) continue;
            const numberAmount = parseFloat(
              stringAmount.replace(/[^\d.-]/g, ""),
            );
            sum = sum + numberAmount;
          }
          // console.log(payroll)
        }

        payroll = sum;

        let modifiedBy;

        if (userData.modifiedBy && userData.modifiedBy in emailToNameMap) {
          modifiedBy = emailToNameMap[userData.modifiedBy.trim().toLowerCase()];
        } else {
          modifiedBy = userData?.modifiedByName || userData.modifiedBy;
        }

        for (let key of userData?.address || []) {
          sortKeyPrepare.push(
            `${userData?.quoteData?.date}@${userData?.quoteData?.uuid}_${userData?.peoDetails?.selectedPeo}+${key}`,
          );
        }

        //  Process to get Governing class code.

        let governingClassCode;
        let govClassCode = [];
        let maxPayroll = -Infinity;
        let govccstate;
        const childrenLoc = userData.childrenLoc;

        // Loop through each location
        if (childrenLoc) {
          Object.values(childrenLoc).map((location) => {
            // Check if classCodesInfo property exists and has values
            if (location.classCodesInfo) {
              // Loop through classCodesInfo to get payroll details
              Object.values(location.classCodesInfo).map((classCode) => {
                if (classCode) {
                  let classCodeobj = {
                    payroll: formatPayrollToNumber(classCode.payroll.value),
                    classCode:
                      classCode.classCodeDescription?.value?.split(":")[0],
                    govccstate: location.state,
                  };
                  govClassCode.push(classCodeobj);
                }
              });
            }
          });
        }
        govClassCode.forEach((item) => {
          if (item.payroll > maxPayroll) {
            maxPayroll = item.payroll;
            governingClassCode = item.classCode;
            govccstate = item.govccstate.value;
          }
        });

        rowData = {
          step,
          questcoId: userData?.questco_submission_id || "",
          submittedDate: userData.status_info?.submit_to_underwriter?.timestamp
            ? moment(
                userData.status_info?.submit_to_underwriter?.timestamp,
                "x",
              ).format("M/D/YY")
            : "-",
          createdDate: userData.createdDate
            ? moment(userData.createdDate, "x").format("M/D/YY")
            : "-",
          uploadTimestamp: userData.uploadTimestamp
            ? moment(userData.uploadTimestamp, "x").format("M/D/YY")
            : "-",
          effectiveDate: userData?.companyProfile?.effectiveDate?.value
            ? moment(userData?.companyProfile?.effectiveDate?.value).format(
                "M/D/YY",
              )
            : "-",
          phoneNumber: userData?.companyProfile?.phoneNumber?.value,
          contactName:
            camelCase(userData?.companyProfile?.firstName?.value) +
            " " +
            camelCase(userData?.companyProfile?.lastName?.value),
          companyName: userData?.companyProfile?.companyName?.value || "-",
          peo: userData?.companyProfile?.peo?.value || "-",
          fein: userData?.companyProfile?.fein?.value,
          modifiedBy: modifiedBy || "-",
          childrenLoc: userData?.childrenLoc,
          payroll: payroll?.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
          }),
          companyProfile: userData?.companyProfile,
          state: userData?.companyProfile?.state1?.value?.toUpperCase() || "-",
          emodStatesData: userData?.emodStatesData,
          uw_ques: userData?.uw_ques,
          user_email_id: userData?.user_email_id,
          status: userData?.status,
          quoteData: userData?.quoteData,
          address: userData?.address,
          status: userData?.status,
          riskProfile: userData?.riskProfile,
          riskProfileId: userData?.riskProfileId,
          targetPremium: userData?.targetPremium,
          peoDetails: userData?.peoDetails,
          carrierList: userData?.carrierList,
          amtrustAccountDetails: userData?.amtrustAccountDetails,
          amtrustAccountDetailsCopy: userData?.amtrustAccountDetailsCopy,
          quoteSubmitted: userData?.quoteSubmitted,
          uw_comments: userData?.uw_comments
            ? typeof userData?.uw_comments === "string"
              ? [userData?.uw_comments]
              : userData?.uw_comments
            : [""],
          agent_comments: userData?.agent_comments
            ? typeof userData.agent_comments === "string"
              ? [userData?.agent_comments]
              : userData?.agent_comments
            : [""],
          uwStatus: userData?.uw_status,
          uuidCarriers: sortKeyPrepare,
          govClassCode: governingClassCode,
          govCCState: govccstate,
          selectedPeo: userData?.peoDetails?.selectedPeo,
          salesforceData: userData?.salesforceData,
          selectedPeoToDisplay: selectedPeoFormat(
            userData?.peoDetails?.selectedPeo,
          ),
          fileList: userData?.fileList ? userData?.fileList : [],
          selectedPeoToDisplay: selectedPeoFormat(
            userData?.peoDetails?.selectedPeo,
          ),
          real_submission: userData.real_submission || "false",
          status_info_rows: [],
          agency: userData?.agency || "-",
          historicalClaims: userData?.historicalClaims || {},
        };

        let _status_info = userData?.status_info || {};

        try {
          for (let status in _status_info) {
            if (status === "underwriting_page_status") {
              for (let carr in _status_info[status]) {
                for (let sts in _status_info[status][carr]) {
                  rowData.status_info_rows.push({
                    status:
                      makeNameReadable(sts) +
                      " (with carrier: " +
                      (carrierMapping[carr] || carr) +
                      ")",
                    timestamp: moment(
                      _status_info[status][carr][sts].timestamp,
                      "x",
                    ).format("MM/DD/YYYY HH:mm:ss"),
                  });
                }
              }
            } else {
              rowData.status_info_rows.push({
                status: makeNameReadable(status),
                timestamp: moment(_status_info[status].timestamp, "x").format(
                  "MM/DD/YYYY HH:mm:ss",
                ),
              });
            }
          }
        } catch (error) {
          console.log(error);
        }

        rowData.status_info_rows.sort((a, b) =>
          a.timestamp < b.timestamp ? 1 : a.timestamp > b.timestamp ? -1 : 0,
        );

        createCommentForDownload(rowData, "uw_comments");
        createCommentForDownload(rowData, "agent_comments");

        _submissionYesNoList[rowData.user_email_id] =
          userData.real_submission === "true" ? true : false;

        _agentCommentsHistory[rowData.user_email_id] = userData?.agent_comments
          ? typeof userData.agent_comments === "string"
            ? [userData?.agent_comments]
            : userData?.agent_comments
          : [""];
        if (rowData.companyName === "-") continue;
        rowDataList.push(rowData);
      } catch (error) {
        console.log("error in: ", userData, error);
      }
    }

    return { rowDataList, _submissionYesNoList, _agentCommentsHistory };
  };

  const getAllData = async () => {
    try {
      let lastEvalKey = null,
        globalDbData = {},
        delayInSeconds = 2000; // we will start with the delay of 2 seconds and keep adding 500ms to it to toggle throttling exception

      do {
        await new Promise((reso, rej) => {
          getAllDataApi(globalDbData, lastEvalKey)
            .then((res) => {
              // console.log("getAllData", res);

              let { dataFromAPI, lastEvaluatedKey } = res;
              lastEvalKey = lastEvaluatedKey;

              // console.log("getAllData", res);

              let rowDataList = [];
              let domainButtonMap = {};

              globalDbData = { ...globalDbData, ...dataFromAPI };

              try {
                for (let domain in dataFromAPI) {
                  let createPreparedData = true;
                  let preparedData = {};

                  for (let domainWiseQuoteData of dataFromAPI[domain]) {
                    let payroll;
                    let classcodeInfo;
                    let sum = 0;

                    let childloc =
                      domainWiseQuoteData["currProspectDetails"]["childrenLoc"];

                    for (let domainWiseQuoteData in childloc) {
                      let userChildlocData = childloc[domainWiseQuoteData];
                      classcodeInfo = userChildlocData.classCodesInfo;
                      classcodeInfo = Object.entries(classcodeInfo);
                      for (let i = 0; i < classcodeInfo.length; i++) {
                        let paydata = classcodeInfo[i];
                        const stringAmount = paydata[1]?.payroll?.value;
                        if (!stringAmount) continue;
                        const numberAmount = parseFloat(
                          stringAmount.replace(/[^\d.-]/g, ""),
                        );
                        sum = sum + numberAmount;
                      }
                      payroll = sum;
                    }

                    //  Process to get Governing class code and Governing class code state.

                    let governingClassCode;
                    let govClassCode = [];
                    let maxPayroll = -Infinity;
                    let govccstate;

                    // Loop through each location
                    if (childloc) {
                      Object.values(childloc).map((location) => {
                        if (location.classCodesInfo) {
                          Object.values(location.classCodesInfo).map(
                            (classCode) => {
                              if (classCode) {
                                let classCodeobj = {
                                  payroll: classCode.payroll.value
                                    ? parseFloat(
                                        classCode.payroll.value.replace(
                                          /[^\d.-]/g,
                                          "",
                                        ),
                                      )
                                    : 0,
                                  classCode:
                                    classCode.classCodeDescription?.value?.split(
                                      ":",
                                    )[0],
                                  govccstate: location.state,
                                };
                                govClassCode.push(classCodeobj);
                              }
                            },
                          );
                        }
                      });
                    }
                    govClassCode.forEach((item) => {
                      if (item.payroll > maxPayroll) {
                        maxPayroll = item.payroll;
                        governingClassCode = item.classCode;
                        govccstate = item.govccstate.value;
                      }
                    });

                    if (createPreparedData) {
                      try {
                        preparedData = {
                          user_email_id: domainWiseQuoteData?.user_email_id,
                          salesforceData: domainWiseQuoteData?.salesforceData,
                          uploadTimestamp:
                            (domainWiseQuoteData?.date
                              ? moment(
                                  Number(domainWiseQuoteData?.date),
                                  "x",
                                ).format("M/D/YY")
                              : "-") || "",
                          submittedDate:
                            (domainWiseQuoteData?.submissionDate
                              ? moment(
                                  Number(domainWiseQuoteData?.submissionDate),
                                  "x",
                                ).format("M/D/YY")
                              : "-") || "",
                          submittedUserName:
                            domainWiseQuoteData?.producerEmail?.split("@")[0] ||
                            "",
                          companyname:
                            domainWiseQuoteData?.currProspectDetails
                              ?.companyProfile?.companyName?.value || "",
                          fein:
                            domainWiseQuoteData?.currProspectDetails
                              ?.companyProfile?.fein?.value || "",
                          peo:
                            domainWiseQuoteData?.currProspectDetails
                              ?.companyProfile?.peo?.value || "",
                          primaryState:
                            domainWiseQuoteData?.currProspectDetails?.companyProfile?.state1?.value?.toUpperCase() ||
                            "-",
                          govClassCode: governingClassCode,
                          govCcState: govccstate,
                          uw_comments: domainWiseQuoteData?.uw_comments
                            ? typeof domainWiseQuoteData?.uw_comments ===
                              "string"
                              ? [domainWiseQuoteData?.uw_comments]
                              : domainWiseQuoteData?.uw_comments
                            : [""],
                          agent_comments: domainWiseQuoteData?.agent_comments
                            ? typeof domainWiseQuoteData?.agent_comments ===
                              "string"
                              ? [domainWiseQuoteData?.agent_comments]
                              : domainWiseQuoteData?.agent_comments
                            : [""],
                          currProspect:
                            domainWiseQuoteData?.currProspectDetails,
                          targetPremium: domainWiseQuoteData?.targetPremium,
                          uuidCarriers: domainWiseQuoteData?.uuid_carrier
                            ? [domainWiseQuoteData?.uuid_carrier]
                            : [],
                          address: domainWiseQuoteData?.uuid_carrier
                            ? [
                                domainWiseQuoteData?.uuid_carrier
                                  ?.split("+")
                                  ?.pop(),
                              ]
                            : [],
                          uw_status: domainWiseQuoteData?.uw_status,
                          fileList: domainWiseQuoteData?.fileList,
                          uwFileList: domainWiseQuoteData?.uwFileList,
                          dealConfirmed: domainWiseQuoteData?.dealConfirmed,
                          selectedPeo:
                            domainWiseQuoteData?.["currProspectDetails"]
                              ?.peoDetails?.selectedPeo || "-",
                          selectedPeoToDisplay: selectedPeoFormat(
                            domainWiseQuoteData?.["currProspectDetails"]
                              ?.peoDetails?.selectedPeo || "-",
                          ),
                          payroll: payroll?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 0,
                          }),
                          amtrustAccountDetails:
                            domainWiseQuoteData?.amtrustAccountDetails || "",
                          amtrustAccountDetails:
                            domainWiseQuoteData?.amtrustAccountDetails || "",
                          amtrustNetRatesResponse:
                            domainWiseQuoteData?.amtrustNetRatesResponse || "",
                          status_info_rows: [],
                        };

                        let _status_info =
                          domainWiseQuoteData?.status_info || {};

                        try {
                          for (let status in _status_info) {
                            if (status === "underwriting_page_status") {
                              for (let carr in _status_info[status]) {
                                for (let sts in _status_info[status][carr]) {
                                  preparedData.status_info_rows.push({
                                    status:
                                      makeNameReadable(sts) +
                                      " (with carrier: " +
                                      (carrierMapping[carr] || carr) +
                                      ")",
                                    timestamp: moment(
                                      _status_info[status][carr][sts].timestamp,
                                      "x",
                                    ).format("MM/DD/YYYY HH:mm:ss"),
                                  });
                                }
                              }
                            } else {
                              preparedData.status_info_rows.push({
                                status: makeNameReadable(status),
                                timestamp: moment(
                                  _status_info[status].timestamp,
                                  "x",
                                ).format("MM/DD/YYYY HH:mm:ss"),
                              });
                            }
                          }
                        } catch (error) {
                          console.log(error);
                        }

                        preparedData.status_info_rows.sort((a, b) =>
                          a.timestamp < b.timestamp
                            ? 1
                            : a.timestamp > b.timestamp
                              ? -1
                              : 0,
                        );

                        if (preparedData.status_info_rows.length) {
                          console.log(preparedData.status_info_rows);
                        }

                        createCommentForDownload(preparedData, "uw_comments");
                        createCommentForDownload(
                          preparedData,
                          "agent_comments",
                        );
                        if (
                          domainWiseQuoteData?.date &&
                          domainWiseQuoteData?.uuid
                        ) {
                          preparedData.quoteData = {
                            uuid: domainWiseQuoteData.uuid,
                            date: domainWiseQuoteData.date,
                          };
                        }

                        let _fileListToStore = [];
                        if (domainWiseQuoteData?.fileList?.length) {
                          domainWiseQuoteData.fileList.forEach((ele) => {
                            _fileListToStore.push(ele.key);
                          });
                        }
                        if (domainWiseQuoteData?.uwFileList?.length) {
                          domainWiseQuoteData.uwFileList.forEach((ele) => {
                            _fileListToStore.push(ele.key);
                          });
                        }
                        preparedData["fileListToStore"] = _fileListToStore;

                        createPreparedData = false;
                      } catch (error) {
                        console.log(error);
                      }
                    } else {
                      if (domainWiseQuoteData?.uuid_carrier) {
                        preparedData.uuidCarriers.push(
                          domainWiseQuoteData.uuid_carrier,
                        );
                        preparedData.address.push(
                          domainWiseQuoteData?.uuid_carrier?.split("+").pop(),
                        );
                      }
                    }
                    if (!(domain in domainButtonMap))
                      domainButtonMap[domain] = {
                        uw_status: domainWiseQuoteData?.uw_status || "Select",
                      };
                  }
                  rowDataList.push(preparedData);
                }
              } catch (error) {}

              // setRowDataList(rowDataList);
              // setDomainButtonMap(domainButtonMap);

              setDomainButtonMap((_domainButtonMap) => {
                return { ..._domainButtonMap, ...domainButtonMap };
              });
              console.log(rowDataList, "rowDatalist");

              setRowDataList((_rowDataList) => [
                ..._rowDataList,
                ...rowDataList,
              ]);
              reso();
            })
            .catch((err) => {
              // setRowDataList([]);
              // setIsLoading((values) => {
              //   return { ...values, tab1: false };
              // });
              // rej();
              delayInSeconds += 500;
              console.log(
                "retrying to fetch the data after " +
                  delayInSeconds +
                  " second again.",
              );
            });
        });
        await delay(delayInSeconds);
        setIsLoading((values) => {
          return { ...values, tab1: false };
        });
      } while (lastEvalKey);
      setDataLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getUWReleasedData = () => {
    try {
      axios
        .post(awsUrl + "/api/underWriterData/uwReleased", {})
        .then((res) => {
          let dataFromAPI = res.data;
          let _releasedRowDataList = [];

          try {
            for (let domain in dataFromAPI) {
              let createPreparedData = true;
              let preparedData = {};

              for (let domainWiseQuoteData of dataFromAPI[domain]) {
                let payroll;
                let classcodeInfo;
                let sum = 0;

                let childloc = domainWiseQuoteData["childrenLoc"];

                for (let domainWiseQuoteData in childloc) {
                  let userChildlocData = childloc[domainWiseQuoteData];
                  classcodeInfo = userChildlocData.classCodesInfo;
                  classcodeInfo = Object.entries(classcodeInfo);
                  for (let i = 0; i < classcodeInfo.length; i++) {
                    let paydata = classcodeInfo[i];
                    const stringAmount = paydata[1]?.payroll?.value;
                    if (!stringAmount) continue;
                    const numberAmount = parseFloat(
                      stringAmount.replace(/[^\d.-]/g, ""),
                    );
                    sum = sum + numberAmount;
                  }
                  payroll = sum;
                }

                try {
                  preparedData = {
                    submittedDate:
                      (domainWiseQuoteData?.submissionDate
                        ? moment(
                            Number(domainWiseQuoteData?.submissionDate),
                            "x",
                          ).format("M/D/YY")
                        : "-") || "",
                    submittedUserName: domainWiseQuoteData?.producerEmail || "",
                    companyname:
                      domainWiseQuoteData?.companyProfile?.companyName?.value ||
                      "",
                    fein:
                      domainWiseQuoteData?.companyProfile?.fein?.value || "",
                    uw_comments: domainWiseQuoteData?.uw_comments || "",
                    agent_comments: domainWiseQuoteData?.agent_comments || "",
                    payroll: payroll?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                    }),
                  };
                } catch (error) {}

                _releasedRowDataList.push(preparedData);
              }
            }
          } catch (error) {}

          _releasedRowDataList.sort(
            (a, b) => new Date(b.submittedDate) - new Date(a.submittedDate),
          );

          setReleasedRowDataList((values) => {
            return [...values, ..._releasedRowDataList];
          });
          setIsLoading((values) => {
            return { ...values, tab2: false, tab3: false };
          });
        })
        .catch((err) => {
          setReleasedRowDataList([]);
          setIsLoading((values) => {
            return { ...values, tab2: false, tab3: false };
          });
        });
    } catch (error) {
      console.log("error in fetching data ", error);
    }
  };

  let NavButtons = () => {
    let tabMap = {
      tab1: "UW dashboard",
      tab2: " Released dashboard",
      tab3: "Archive",
    };
    return (
      <>
        <div className="d-flex flex-wrap gap-3">
          {Object.keys(tabMap).map((tab) => {
            return (
              <>
                <button
                  className={`btn ${
                    tabsCheck[[tab]] ? " btn-primary" : "btn-secondary"
                  }`}
                  onClick={() => {
                    setTabsCheck((values) => {
                      Object.keys(values).forEach((item) => {
                        values[item] = false;
                      });
                      return { ...values, [tab]: true };
                    });
                  }}
                >
                  {tabMap[tab]}
                </button>
              </>
            );
          })}
        </div>
      </>
    );
  };
  const tab1Table = setTableData(rowDataList, columnData, isLoading["tab1"]);

  const tab2Table = setTableData(
    releasedRowDataList,
    releasedColumnData,
    isLoading["tab2"],
  );

  const tab3Table = setTableData(
    archiveRowDataList,
    archiveColumnData,
    isLoading["tab3"],
  );

  let { showModel, modalTitle, modalContent } = modalData;
  return (
    <>
      <div className={"Submission-uw-dashboard"} style={style}>
        <NavButtons />
        {tabsCheck["tab1"] && (
          <div>
            {dataLoading ? (
              <div style={{ marginLeft: "50%" }}>
                <RotatingLines
                  visible={true}
                  height="40"
                  width="40"
                  color="black"
                  strokeColor="grey"
                  strokeWidth="5"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
                <b>Data Loading.....</b>
              </div>
            ) : (
              <div style={{ marginLeft: "50%" }}></div>
            )}
            <div ref={myRef}>{tab1Table}</div>
          </div>
        )}

        {tabsCheck["tab2"] && <div>{tab2Table}</div>}

        {tabsCheck["tab3"] && <div>{tab3Table}</div>}

        {/* comments history modal */}
        {uwButton ? (
          <Dialog open={openModal} onClose={handleCloseModal}>
            <DialogTitle>
              <p style={{ textAlign: "center" }}>
                {(modalBody.length > 0 &&
                  modalBody[0] !== "" &&
                  modalBody?.[0]?.comments !== "") ||
                modalBody?.[0]?.previousComment
                  ? "Comment History"
                  : "No Comment History"}
              </p>
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
                style={{ position: "absolute", right: "5px", top: "8px" }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {modalBody.length > 0 &&
                modalBody[0] !== "" &&
                modalBody.map((item, index) => {
                  let date = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[0];
                  let time = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[1];
                  if (item.comment !== "") {
                    if (item.commentTimestamp || item.email || item) {
                      return (
                        <div>
                          <div>
                            <span>
                              <b>{date}</b>
                            </span>
                            <span
                              style={{
                                marginLeft: "10px",
                                marginRight: "10px",
                              }}
                            >
                              <b>{time}</b>
                            </span>
                            <span>{item.email ? "- " : ""}</span>
                            <span>
                              <b>{item.email?.split("@")[0]}</b>
                            </span>
                          </div>
                          <div>
                            <p>
                              {item?.comment
                                ? item.comment
                                : modalBody[index + 1]?.comment
                                  ? modalBody[index + 1].comment
                                  : item}
                            </p>
                          </div>
                          <br />
                        </div>
                      );
                    }
                  } else {
                    return;
                  }
                })}
            </DialogContent>
          </Dialog>
        ) : (
          <Dialog open={openModal} onClose={handleCloseModal}>
            <DialogTitle>
              <p style={{ textAlign: "center" }}>
                {(modalBody.length > 0 && modalBody[0]?.comment !== "") ||
                modalBody?.[0]?.previousComment
                  ? "Comment History"
                  : "No Comment History"}
              </p>
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
                style={{ position: "absolute", right: "5px", top: "8px" }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {modalBody.length > 0 &&
                modalBody[0] !== "" &&
                modalBody.map((item, index) => {
                  let date = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[0];
                  let time = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[1];
                  if (item.comment !== "") {
                    if (item.commentTimestamp || item.email || item) {
                      return (
                        <div>
                          <div>
                            <span>
                              <b>{date}</b>
                            </span>
                            <span
                              style={{
                                marginLeft: "10px",
                                marginRight: "10px",
                              }}
                            >
                              <b>{time}</b>
                            </span>
                            <span>{item.email ? "- " : ""}</span>
                            <span>
                              <b>{item.email?.split("@")[0]}</b>
                            </span>
                          </div>
                          <div>
                            <p>
                              {item?.comment
                                ? item.comment
                                : modalBody[index + 1]?.comment
                                  ? modalBody[index + 1].comment
                                  : item}
                            </p>
                          </div>
                          <br />
                        </div>
                      );
                    }
                  } else {
                    return;
                  }
                })}
            </DialogContent>
          </Dialog>
        )}

        {/* Release button modal */}
        <Modal
          show={showModel}
          onHide={() => {
            setModalData({
              showModel: false,
              modalTitle: null,
              modalContent: null,
            });
          }}
          dialogClassName="model-download modal-dialog-centered"
        >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modalContent}</Modal.Body>
        </Modal>
      </div>
      <Toaster />
      {popupData.show && (
        <Popup popupData={popupData} updatePopUpData={updatePopUpData} />
      )}
    </>
  );
};

function TextField(props) {
  const [value, setValue] = useState("");
  const [loggedInEmail, setLoggedInEmail] = useState("");

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    loggedInEmailId();
  }, []);

  let loggedInEmailId = async () => {
    try {
      let sessionData = props.user;
      setLoggedInEmail(sessionData["attributes"]["email"]);
    } catch (error) {
      console.error("Error fetching authenticated user:", error);
    }
  };

  return (
    <textarea
      value={value || ""}
      className="underwriter_comment"
      rows="1"
      style={{
        width: "100%",
        backgroundColor: setCommentBoxColor(props?.comments),
      }}
      onChange={(e) => setValue(e.target.value)}
      disabled={props.agent_comments ? true : props.uw_disabled ? true : false}
      onBlur={(e) => {
        let uwCommentsCopy = props.rowData.uw_comments;

        let currentTimestamp = moment().valueOf();
        let dataToSave = {};

        if (uwCommentsCopy === undefined && e.target.value.trim() !== "") {
          uwCommentsCopy = [
            {
              comment: e.target.value.trim(),
              commentTimestamp: currentTimestamp,
              email: loggedInEmail,
            },
          ];
        } else if (
          e.target.value.length === 0 ||
          e.target.value.trim() === ""
        ) {
          if (uwCommentsCopy === undefined) {
            return;
          } else if (
            uwCommentsCopy[0]?.comment &&
            e.target.value.trim() !== uwCommentsCopy[0]?.comment
          ) {
            uwCommentsCopy.unshift({
              comment: e.target.value.trim(),
              commentTimestamp: currentTimestamp,
              previousComment: "true",
              email: loggedInEmail,
            });
          } else if (
            uwCommentsCopy[0] &&
            typeof uwCommentsCopy[0] === "string"
          ) {
            e.target.value.trim() !== uwCommentsCopy[0] &&
              uwCommentsCopy.unshift({
                comment: e.target.value.trim(),
                commentTimestamp: currentTimestamp,
                previousComment: "true",
                email: loggedInEmail,
              });
          } else {
            console.log("I m returning as value is 0");
            return;
          }
        } else if (typeof uwCommentsCopy[0] === "string") {
          e.target.value.trim() !== uwCommentsCopy[0] &&
            uwCommentsCopy.unshift({
              comment: e.target.value.trim(),
              commentTimestamp: currentTimestamp,
              email: loggedInEmail,
            });
        } else {
          e.target.value.trim() !== uwCommentsCopy[0].comment &&
            uwCommentsCopy.unshift({
              comment: e.target.value.trim(),
              commentTimestamp: currentTimestamp,
              email: loggedInEmail,
            });
        }

        dataToSave.user_email_id = props.rowData.user_email_id;
        dataToSave.sortKeyList = props.rowData.uuidCarriers;
        dataToSave.uw_comments = uwCommentsCopy;
        dataToSave.uw_comments && props.callback(dataToSave);
      }}
    ></textarea>
  );
}

export default UnderWriterTab;
